import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Tooltip } from '@mui/material';
import { useState } from 'react';
import axios from '../../util/Axios';
import AddIcon from '@mui/icons-material/AddCircleOutline';

export function EditInformedConsentNumber({ open, testId, informedConsentNo, handleClose }) {
  const [informedConsentNumber, setInformedConsentNumber] = useState(informedConsentNo);

  const handleGenereateNumber = () => {
    axios.post('/informedConsentCode/generate').then((resp) => {
      setInformedConsentNumber(resp.data?.id);
    });
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">Edit Informed Consent Number</DialogTitle>
        <DialogContent>
          <Stack spacing={2} direction="row" alignItems="center">
            <TextField autoFocus margin="dense" id="informedConsentNumber" label="Informed Consent Number" type="text" fullWidth value={informedConsentNumber} onChange={(e) => setInformedConsentNumber(e.target.value)} />
            <IconButton onClick={() => handleGenereateNumber()}>
              <Tooltip title="Generate number">
                <AddIcon />
              </Tooltip>
            </IconButton>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              axios.put('/strokeTests/' + testId + '/details/informedConsent', { value: informedConsentNumber }).then((resp) => {
                handleClose();
              });
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
